module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTE3MiIgaGVpZ2h0PSIxNDMyIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMSkiIHN0cm9rZT0iIzI3MjcyNyIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIG9wYWNpdHk9Ii40MTMiIGN4PSI3MTUiIGN5PSI3OTQiIHI9IjMxNyIvPjxjaXJjbGUgb3BhY2l0eT0iLjIzOSIgY3g9IjcxNS41IiBjeT0iNzk0LjUiIHI9IjQxNy41Ii8+PGNpcmNsZSBvcGFjaXR5PSIuMTIzIiBjeD0iNzE1IiBjeT0iNzk1IiByPSI1NTciLz48Y2lyY2xlIG9wYWNpdHk9Ii4wNjUiIGN4PSI3MTUiIGN5PSI3MTUiIHI9IjcxNSIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mercedes-circle-basic.svg
// module id = QhTD
// module chunks = 0